// only when you want to access your app on mobile on local network set domain to - http://192.168.0.158:5000
// else leave above domain variable to emprty string/
// let domain = "enter manual domain here"
let domain = "";
// let domain = "http://192.168.0.158:5001";
if (domain.length < 1) {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    // dev code
    domain = "http://localhost:5001";
  } else {
   

    domain = "https://api.foodiepenguin.com";
    // production code
  }
}
module.exports = domain;
